import * as Mustache from "mustache";
import {IApiResponse} from "../../common/interfaces/IApiResponse";
import {get as getCookie} from "es-cookie";
import {Language} from "../../common/interfaces/Language";

const LABELS_API_URL = '/api/kws/labels';

class TranslationsService {
	private strings: any = {};
	private _initialized: boolean = false;

	// Insure that there's a single instance of translationsService shared by all components
	static _instance: TranslationsService;

	static getInstance(): TranslationsService {
		return TranslationsService._instance || new TranslationsService();
	}

	get initialized() {
		return this._initialized;
	}

	constructor() {
		if (!TranslationsService._instance) {
			TranslationsService._instance = this;
		}

		return TranslationsService._instance;
	}

	addTranslations(element) {
		if (document.getElementById(element)) {
			try {
				let translationStrings = JSON.parse( document.getElementById(element).innerHTML );
				this.init(translationStrings);
			} catch(e) {
				console.log('Unable to add translations from ' + element);
			}
		}
	}

	init(strings: any) {
		(<any>Object).assign(this.strings, strings);
		this._initialized = true;
	}

	translate(key: string, fallback?: string, data?: any) {
		if (!this.strings.hasOwnProperty(key)) {
			return fallback || `#Key not found: ${key}#`;
		}

		if (data) {
			return Mustache.render(this.strings[key], data);
		} else {
			return this.strings[key];
		}
	}

	lookup(key: string) {
		let language = getCookie('language') || Language.EN;
		let url = `${LABELS_API_URL}?key=${key}&language=${language}`;

		let request = fetch(url)
			.then(response => response.json())
			.then((response: any) => {
				// console.log(response);
				if (!response.errorDetail.isError) {
					if (response.data.hasOwnProperty(key)) {
						this.strings[key] = response.data[key];
					}
				}
			})
			.catch(error => console.error('Error:', error));

		return request;

	}
}

export default TranslationsService;



// WEBPACK FOOTER //
// ./src/ts/Apps/Common/Services/translations.service.ts